import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";

/**
 * Entrada del perito vía iframe del ERP.
 *   /expert/:id?t=<JWT temporal>
 *
 * Guarda el JWT como token de auth, refresca el contexto y redirige a /call/:id.
 */
export default function ExpertEntry() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState({ ready: false, ok: false, error: null });

  useEffect(() => {
    const t = params.get("t");
    if (!t) {
      setState({ ready: true, ok: false, error: "Falta token (?t=...)" });
      return;
    }
    localStorage.setItem("vp_token", t);
    // Higiene de URL: quita el token de la barra de direcciones y del
    // historial del navegador en cuanto lo hemos guardado en sesión. Evita
    // que quede expuesto en logs de proxy, referers y compartidos accidentales.
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("t");
      window.history.replaceState({}, "", url.toString());
    } catch (err) {
      console.warn("[ExpertEntry] no se pudo limpiar el token de la URL", err);
    }
    (async () => {
      const user = await refresh();
      if (user) setState({ ready: true, ok: true, error: null });
      else setState({ ready: true, ok: false, error: "Token inválido o expirado. Pide al ERP que genere uno nuevo." });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  if (!state.ready) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0F172A] text-white text-sm">Iniciando sala…</div>;
  }
  if (!state.ok) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F172A] text-white text-sm px-6 text-center">
        <div>
          <div className="font-heading text-lg font-bold mb-2">No se pudo abrir la sala</div>
          <div className="text-blue-200/80">{state.error}</div>
        </div>
      </div>
    );
  }
  return <Navigate to={`/call/${id}`} replace />;
}
